export enum PartnerEligibilityStatus {
  ELIGIBLE = "ELIGIBLE",
  NOT_ELIGIBLE = "NOT_ELIGIBLE",
  POTENTIALLY_ELIGIBLE_MISSING_CARROT_PLAN = "POTENTIALLY_ELIGIBLE_MISSING_CARROT_PLAN",
  POTENTIALLY_ELIGIBLE_MISSING_INSURANCE_ENROLLMENT = "POTENTIALLY_ELIGIBLE_MISSING_INSURANCE_ENROLLMENT",
  POTENTIALLY_ELIGIBLE_MISSING_PARTNER_INFO = "POTENTIALLY_ELIGIBLE_MISSING_PARTNER_INFO"
}
